import React from 'react';
import { useSelector } from 'react-redux';
import { BaseTable } from 'modules/proposals';
import { IS_DEVELOPMENT } from 'constants/common';
import { Proposal } from '@trnsact/trnsact-shared-types';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';

interface Props {
  customerProposals: Proposal[];
}

export const ProposalsCard = ({ customerProposals }: Props) => {
  const account = useSelector((state: any) => state.account);

  const handleGoToProposalDetail = (proposal: Proposal) => {
    window.open(
      `https://app${
        IS_DEVELOPMENT ? '.dev' : ''
      }.trnsact.com/ps/?vendorGUID=${account.dynamicsAccountId}&proposalId=${proposal.proposalId}&viewOnly=true`,
      '_blank'
    );
  };

  const handleGoToProposal = (proposal: Proposal) => {
    window.open(`/proposalDetail/${proposal.proposalId}?from=/vo/${proposal.vendorOpportunityId}`, '_blank');
  };

  return (
    <CardContainer title="Proposals">
      <BaseTable
        onGoToProposal={handleGoToProposal}
        onGoToProposalDetail={handleGoToProposalDetail}
        tableData={customerProposals}
      />
    </CardContainer>
  );
};
